
const CheckBoxWithTitle = (props: any) => {
    return (
        <div className="checkbox-container">
            <div className="filter-fields">
                <h3 className="title">
                    {props.title}
                </h3>
                <div>
                    <input type="checkbox" name={props.name} value={props.value} />
                </div>
            </div>

        </div>
    )
}

export default CheckBoxWithTitle